/* src/app/front-layout/creative-writing/creative-writing.component.css */
.wa {
  color: #03a71b;
}
.main-card {
  background: #f8f8f7;
  margin: 0 auto;
}
.spacer {
  height: 50px;
}
.card-content {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.left-col {
  flex: 1 1 60%;
  padding: 30px;
}
.left-col h1 {
  margin-top: 100px;
  font-size: 48px;
  font-weight: 600;
  margin-bottom: 10px;
}
.left-col .highlight {
  font-weight: 800;
}
.subtitle {
  color: #444;
  font-size: 20px;
  margin-bottom: 20px;
}
.info-list {
  margin-top: 26px;
}
.info-item {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}
.icon {
  width: 50px;
  font-size: 25px;
  margin-right: 5px;
  color: #007BA7;
}
.l-label {
  font-size: 20px;
  color: #222;
}
.booking-card {
  width: 80%;
  background: #fff;
  margin: 34px 0 0 0;
  display: flex;
  align-items: center;
  border-radius: 12px;
  box-shadow: 0px 4px 16px 0px rgba(80, 80, 80, 0.1);
  padding: 24px 20px;
  justify-content: space-between;
}
.book-btn {
  width: 250px;
  background: #007BA7;
  border: none;
  color: #fff;
  padding: 16px 36px;
  border-radius: 30px;
  font-size: 20px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
  margin-right: 32px;
}
.price {
  font-size: 36px;
  font-weight: 700;
  color: #03a71b;
}
.strike-price {
  font-size: 3rem;
  position: relative;
  color: #070707;
  font-weight: bold;
}
.strike-price::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 4px;
  background-color: red;
  transform: translateY(-50%);
}
.last-booking {
  margin: 18px 0 0 10px;
  font-size: 20px;
}
.last-booking .orange {
  color: #007BA7;
  font-weight: 600;
}
.right-col {
  flex: 1 1 40%;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
}
.right-col img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.bottom-info {
  margin-top: -40px;
  display: flex;
  justify-content: center;
}
.bottom-card {
  background: #fff;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
  box-shadow: 0px 4px 16px 0px rgba(80, 80, 80, 0.1);
  border-radius: 15px;
  padding: 28px 20px;
  width: 80%;
}
.bottom-item {
  flex: 1 1 23%;
  align-items: center;
  text-align: center;
  border-right: 1px solid #ddd;
  padding: 0 28px;
  min-width: 130px;
}
.bottom-item:last-child {
  border: none;
}
.bottom-item .icon {
  color: #007BA7;
  font-size: 24px;
  margin-bottom: 5px;
}
.bottom-label {
  font-size: 22px;
  font-weight: 600;
  color: #515151;
  display: block;
  margin-bottom: 10px;
}
.bottom-value {
  font-size: 18px;
}
.bottom-value.strong {
  font-weight: 700;
}
.section-goal-wrapper {
  margin-top: 50px;
  background: #ffffff;
  padding-bottom: 48px;
}
.goal-bar {
  display: flex;
  align-items: stretch;
  width: 100%;
  background: #fafafa;
  height: 150px;
}
.goal-left {
  background: #007BA7;
  color: #fff;
  font-size: 2rem;
  font-weight: 500;
  min-width: 500px;
  display: flex;
  align-items: center;
  padding-left: 44px;
  clip-path: polygon(0 0, 100% 0, 80% 100%, 0 100%);
}
.goal-left span {
  display: block;
  font-size: 42px;
  font-weight: 600;
}
.goal-right {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 32px;
  color: #222;
  padding: 0 38px 0 20px;
}
.about-course {
  margin-top: 50px;
  max-width: 950px;
  margin: 38px auto 0 auto;
  text-align: center;
  padding: 0 12px;
}
.about-course h2 {
  font-size: 4rem;
  font-weight: 600;
  margin-bottom: 16px;
}
.about-course .desc-bold {
  font-size: 2rem;
  margin-bottom: 10px;
}
.about-course .desc {
  color: #222;
  font-size: 1.5rem;
}
.sessions-overview-row {
  max-width: 1200px;
  margin: 42px auto 0 auto;
  background: #fff;
  box-shadow: 0 2px 16px rgba(92, 92, 92, 0.08);
  border-radius: 10px;
  display: flex;
  align-items: stretch;
  min-height: 300px;
}
.session-features {
  flex: 3 1 0;
  padding: 36px 36px 36px 48px;
  display: flex;
  align-items: center;
}
.session-features ul {
  list-style: disc inside;
  font-size: 2rem;
  color: #222;
  padding-left: 0;
  margin: 0;
}
.session-features li {
  margin-bottom: 16px;
}
.session-side-box {
  background: #007BA7;
  color: #fff;
  min-width: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 4rem;
  font-weight: 600;
  border-radius: 0 10px 10px 0;
  clip-path: polygon(20% 0, 100% 0, 100% 100%, 0 100%);
  padding: 0 34px;
  text-align: center;
}
.session-side-box span {
  display: block;
}
.section-breakdown {
  max-width: 80%;
  margin: 0 auto 56px auto;
  padding: 0 12px;
}
.section-breakdown h2 {
  text-align: center;
  font-size: 4rem;
  margin: 36px 0 28px 0;
  font-weight: 600;
  color: #151515;
}
.accordion {
  width: 100%;
}
.accordion-item {
  background: #fafafa;
  border: 1px solid #ececec;
  border-radius: 2px;
  margin-bottom: 18px;
  overflow: hidden;
  transition: box-shadow 0.22s;
}
.accordion-item.open {
  background: #f5f5f5;
  box-shadow: 0 3px 18px rgba(70, 70, 70, 0.04);
}
.accordion-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  padding: 18px 24px 18px 16px;
  background: rgba(0, 0, 0, 0.04);
  font-size: 2rem;
  font-weight: 600;
  border-bottom: 1px solid #ededed;
  -webkit-user-select: none;
  user-select: none;
  transition: background 0.18s;
}
.accordion-item:not(.open) .accordion-header {
  border-bottom: none;
}
.accordion-header:hover {
  background: #efeae7;
}
.accordion-icon {
  transition: transform 0.33s cubic-bezier(.45, 1.59, .42, .98);
}
.accordion-item.open .accordion-icon {
  transform: rotate(180deg);
}
.accordion-content {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
  padding: 0 24px;
  background: #fff;
  font-size: 1.5rem;
  color: #181818;
  transition: all 0.36s cubic-bezier(.55, 1.76, .51, 1);
}
.accordion-item.open .accordion-content {
  max-height: 900px;
  opacity: 1;
  padding: 18px 24px 20px 24px;
  border-top: none;
}
.accordion-content ul {
  margin: 0 0 10px 0;
  padding-left: 20px;
}
.accordion-content li {
  margin-bottom: 7px;
}
.guidelines-card {
  background: #fff;
  border: 1.5px solid #f1f1f1;
  max-width: 80%;
  margin: 40px auto 60px auto;
  border-radius: 3px;
  padding: 36px 42px 30px 42px;
  box-sizing: border-box;
  text-align: center;
}
.guidelines-card h2 {
  font-size: 4rem;
  font-weight: 700;
  margin-bottom: 32px;
}
.guidelines-card ul {
  text-align: left;
  margin-bottom: 42px;
  padding-left: 0;
  list-style: disc outside;
  line-height: 40px;
}
.guidelines-card li {
  font-size: 2rem;
  margin-bottom: 24px;
}
.guidelines-card li strong {
  font-weight: 700;
}
.button-row {
  text-align: center;
  margin-top: 16px;
}
.action-btn {
  background: #007BA7;
  color: #fff;
  font-size: 2rem;
  font-weight: 500;
  border: none;
  border-radius: 40px;
  padding: 20px 0;
  width: 320px;
  cursor: pointer;
  transition: background 0.2s;
  margin: 0 auto;
  display: block;
}
.action-btn:hover {
  background: #d15610;
}
.contact-card {
  background: #fff;
  border: 1.5px solid #f1f1f1;
  max-width: 80%;
  margin: 36px auto 60px auto;
  border-radius: 5px;
  box-shadow: 0 2px 16px rgba(220, 120, 40, 0.06);
  padding: 36px 32px 32px 32px;
  text-align: center;
}
.contact-icon-row {
  margin-bottom: 18px;
}
.contact-icon {
  font-size: 4rem;
  color: #007BA7;
  background: #fff3ea;
  border-radius: 50%;
  padding: 18px 22px;
  display: inline-block;
}
.contact-card h2 {
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 18px;
}
.contact-desc {
  font-size: 2rem;
  color: #444;
  margin-bottom: 24px;
  line-height: 1.5;
}
.contact-list {
  list-style: none;
  padding: 0;
  margin-bottom: 26px;
  text-align: left;
  font-size: 2rem;
  max-width: 320px;
  margin-left: auto;
  margin-right: auto;
}
.contact-list li {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
}
.contact-list i {
  color: #02a805;
  margin-right: 12px;
  min-width: 1.3em;
}
.contact-list a {
  color: #333;
  text-decoration: none;
  transition: color 0.18s;
}
.contact-list a:hover {
  color: #007BA7;
  text-decoration: underline;
}
.contact-btn-row {
  margin-top: 16px;
}
.contact-btn {
  background: #007BA7;
  color: #fff;
  font-size: 1.20rem;
  border: none;
  border-radius: 40px;
  padding: 18px 0;
  width: 220px;
  cursor: pointer;
  font-weight: 600;
  letter-spacing: 0.1em;
  box-shadow: 0 2px 10px rgba(243, 127, 29, 0.03);
  transition: background 0.2s;
}
.contact-btn:hover {
  background: #d15610;
}
@media (max-width: 768px) {
  .strike-price {
    font-size: 2rem;
  }
  .card-content {
    margin-top: 100px;
    flex-direction: column;
  }
  .left-col {
    padding: 20px;
  }
  .left-col h1 {
    margin-top: 30px;
    font-size: 32px;
  }
  .subtitle {
    font-size: 18px;
  }
  .right-col img {
    max-height: 400px;
    object-fit: cover;
  }
  .bottom-card {
    flex-direction: column;
    width: 90%;
    padding: 20px;
  }
  .bottom-item {
    border-right: none;
    border-bottom: 1px solid #ddd;
    padding: 20px 0;
    width: 100%;
  }
  .bottom-item:last-child {
    border-bottom: none;
  }
  .goal-bar {
    flex-direction: column;
    height: auto;
  }
  .goal-left {
    clip-path: none;
    min-width: auto;
    padding: 20px;
    justify-content: center;
  }
  .goal-left span {
    font-size: 24px;
  }
  .goal-right {
    padding: 20px;
    font-size: 20px;
    text-align: center;
  }
  .sessions-overview-row {
    flex-direction: column-reverse;
    margin: 20px auto;
  }
  .session-side-box {
    clip-path: none;
    min-width: auto;
    padding: 30px;
    border-radius: 10px 10px 0 0;
    font-size: 24px;
  }
  .session-features {
    padding: 30px 20px;
  }
  .session-features ul {
    font-size: 16px;
  }
  .section-breakdown {
    max-width: 90%;
  }
  .section-breakdown h2 {
    font-size: 28px;
  }
  .accordion-header {
    font-size: 18px;
    padding: 15px;
  }
  .accordion-content {
    font-size: 16px;
    padding: 0 15px;
  }
  .guidelines-card {
    max-width: 90%;
    padding: 30px 20px;
  }
  .guidelines-card h2 {
    font-size: 28px;
  }
  .guidelines-card li {
    font-size: 16px;
    line-height: 1.5;
  }
  .action-btn {
    width: 100%;
    max-width: 300px;
    font-size: 16px;
    padding: 15px;
  }
  .contact-card {
    max-width: 90%;
    padding: 30px 20px;
  }
  .contact-card h2 {
    font-size: 24px;
  }
  .contact-desc {
    font-size: 16px;
  }
  .contact-list {
    font-size: 16px;
    max-width: 100%;
  }
  .l-label {
    font-size: 16px;
  }
  .booking-card {
    width: 100%;
    flex-direction: column;
    gap: 20px;
  }
  .book-btn {
    width: 100%;
    max-width: 300px;
    margin-right: 0;
    font-size: 16px;
  }
  .price {
    font-size: 24px;
  }
  .about-course h2 {
    font-size: 28px;
  }
  .about-course .desc-bold {
    font-size: 18px;
  }
  .about-course .desc {
    font-size: 16px;
  }
}
@media (max-width: 480px) {
  .left-col h1 {
    font-size: 28px;
  }
  .session-side-box {
    font-size: 20px;
    padding: 20px;
  }
  .goal-right {
    font-size: 18px;
  }
}
.wa {
  color: #03a71b;
}
/*# sourceMappingURL=creative-writing.component.css.map */
